// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__-Z42j","col":"styles_col__1NprY","fulfillmentStatus":"styles_fulfillmentStatus__pz4TP","emailCol":"styles_emailCol__2NP11"};